export default "__VITE_ASSET__DsIgy4hM__"